import { IUser } from "../models";
import config from "../../config";

const UI_HIDE_INTERCOM_KEY = "hideIntercom";

declare global {
  interface Window { Intercom: any; }
}

type CurrentUser = IUser | undefined | null;

export function initIntercom(user: CurrentUser) {
  if (!user) {
    return false;
  }

  if (!!window.Intercom && window.localStorage.getItem(UI_HIDE_INTERCOM_KEY) !== 'true') {
    const userHash = document.getElementById('user_hash') as HTMLInputElement;
    // Intercom accepts Unix timestamp in seconds
    const createdAtTimestamp = Math.round(new Date(user.created_on).getTime() / 1000);
    const orgCreatedAtTimestamp = Math.round(new Date(user.current_organization_created_at).getTime() / 1000);
    const name = user.first_name ? `${user.first_name} ${user.last_name}` : user.email.split('@')[0];

    window.Intercom('boot', {
      app_id: config.intercom.appId,
      name: name,
      avatar: user.avatar,
      email: user.email,
      user_id: user.uid,
      created_at: createdAtTimestamp,
      user_hash: userHash.value,
      company: {
        id: user.current_organization_uid,
        name: user.current_organization_name,
        created_at: orgCreatedAtTimestamp
      },
      hide_default_launcher: true, // defined it initially to hide the launcher
    });

    return true;
  } else {
    console.log(`[warning] Intercom is not initialized`);
  }

  return false;
}

export function showIntercomChat(user: CurrentUser) {
  initIntercom(user);
  if (!!window.Intercom) {
    window.Intercom('show');
  }
}

export function showIntercomDefaultLauncher(user: CurrentUser) {
  initIntercom(user);
  if (!!window.Intercom) {
    window.Intercom('update', { hide_default_launcher: false });
  }
}

export function hideIntercomChat(user: CurrentUser) {
  if (!!window.Intercom) {
    try {
      window.Intercom('update', { hide_default_launcher: true });
    } catch (e) {
      console.log(`[warning] Intercom is not initialized error: ${e}`);
    }
  }
}
